import {
  FEATURE_AGENTS_PROFILES_ASSOCIATION,
  FEATURE_AGENTS_PRINCIPALS_MANAGEMENT,
  FEATURE_AGENTS_MATCH_PROBLEM,
} from "@/constants";
import Agents from "@/views/Agents.vue";
import ProfilesAssociation from "@/views/Agents/ProfilesAssociation.vue";
import PrincipalsCompanyManagement from "@/views/Agents/PrincipalsCompanyManagement.vue";
import ConflictsRegistry from "@/views/Agents/ConflictsRegistry.vue";
import DuplicatedProductsManagement from "@/views/Agents/DuplicatedProductsManagement.vue";
import AgentCompanyAssociationDuplicates from "@/views/Agents/AgentCompanyAssociationDuplicates.vue";

const routes = [
  {
    path: "/agents",
    component: Agents,
    children: [
      {
        path: "profiles-association",
        component: ProfilesAssociation,
        name: "ProfilesAssociation",
        meta: {
          allowAgents: true,
          feature: FEATURE_AGENTS_PROFILES_ASSOCIATION,
        },
      },
      {
        path: "principals-management",
        component: PrincipalsCompanyManagement,
        name: "PrincipalsCompanyManagement",
        meta: {
          allowAgents: true,
          feature: FEATURE_AGENTS_PRINCIPALS_MANAGEMENT,
        },
      },
      {
        path: "conflicts-registry",
        component: ConflictsRegistry,
        name: "ConflictsRegistry",
        meta: {
          allowAgents: true,
          feature: FEATURE_AGENTS_MATCH_PROBLEM,
        },
      },
      {
        path: "duplicated-products-management",
        component: DuplicatedProductsManagement,
        name: "DuplicatedProductsManagement",
        meta: {
          allowAgents: true,
          feature: FEATURE_AGENTS_MATCH_PROBLEM,
        },
      },
      {
        path: "agents-company-association-duplicates",
        component: AgentCompanyAssociationDuplicates,
        name: "AgentCompanyAssociationDuplicatesManagement",
        meta: {
          allowAgents: true,
          feature: FEATURE_AGENTS_PRINCIPALS_MANAGEMENT,
        },
      },
    ],
  },
];

export default routes;
